import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Meta Tags Component
 * Updates page-specific meta tags for better search engine optimization
 */
function SEOHelmet({ 
  title = 'Code It Up 6.0 - Ultimate AI & Development Hackathon',
  description = 'Code It Up 6.0 is an exciting hackathon event bringing together developers and AI enthusiasts. Join us for coding challenges, AI workshops, and networking opportunities.',
  keywords = 'hackathon, code it up, coding competition, AI hackathon, developer event',
  canonical = 'https://code-it-up-6.netlify.app/',
  ogTitle,
  ogDescription,
  ogImage = 'https://code-it-up-6.netlify.app/logo.png',
  ogType = 'website'
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph Tags */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Code It Up 6.0" />
      
      {/* Twitter Tags */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={ogTitle || title} />
      <meta property="twitter:description" content={ogDescription || description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}

export default SEOHelmet;
